import Hero from './../components/hero/hero';
import Services from './../components/services/services';
import Contacts from './../components/contacts/contacts';
import Carousel from './../components/carousel/carousel';
import FloatingActionButton from './../components/floatingActionButton/floatingActionButton';

type Props = {
    arg?: String;
};

function HomePage(props: Props) {

    return (
        <div>
            <Hero />
            <Services />
            <Carousel />
            <Contacts />
            <FloatingActionButton />
        </div>
    );
}

export { HomePage };